import BusinessProducts from './business-products';
import ScrollSectionsFixed from '../../../helpers/scroll-sections-fixed';

export default class BusinessProductsDesktop extends BusinessProducts {
    constructor(...args) {
		super(...args);

		window.onload = ()=> {
			this._loadScroller();
		}
	}

	_loadScroller() {
		this.ScrollSectionsFixed = new ScrollSectionsFixed({
			dom: {
				summary: {
					parent: this.dom.views.summaryParent,
					items: this.dom.views.summarys
				},
				sections: {
					parent: this.dom.views.sectionsParent,
					items: this.dom.views.sectionsContent
				}
			},
			params: {
				hasDuration: true,
				hasOffset: 150
			}
		});
	}

	_retrieveDOM() {
		super._retrieveDOM();
		
		this.dom.views.summaryParent = this.dom.page.querySelector('.js-summary-parent');
		this.dom.views.summarys = this.dom.page.querySelectorAll('.js-summary');
		this.dom.views.sectionsParent = this.dom.page.querySelector('.js-sections-parent');
		this.dom.views.sectionsContent = this.dom.page.querySelectorAll('.js-section-content');
	}

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/business/products/business-products.desktop.js